import { animated, useSpring } from '@react-spring/web'
import { CircleChevronRight } from 'lucide-react'

const RotatingCircleRightChevron = ({
  isOpen,
  stroke = '#FFFFFF',
  fill = '#919191',
}: {
  isOpen: boolean
  stroke?: string
  fill?: string
}) => {
  const transform = isOpen ? 'rotate(90deg)' : 'rotate(0deg)'

  const styles = useSpring({
    transform,
  })

  return (
    <animated.span
      className='ease-linear transition-transform duration-100 ml-1'
      style={styles}
    >
      <CircleChevronRight size={30} fill={fill} stroke={stroke} />
    </animated.span>
  )
}

export default RotatingCircleRightChevron
